import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Home from "./components/Home";
import FavoriteLinks from "./components/FavoriteLinks";
import OrderComplete from "./components/OrderComplete";
import DesktopCart from "./components/DesktopCart";
import DesktopOrderComplete from "./components/DesktopOrderComplete";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-83857879-1');
ReactGA.pageview('/webapp');


class App extends Component {
    render() {
        //"favorites" in this case links to the page and not the tab
        return (
            <BrowserRouter forceRefresh={false}>

                <Route path="/webapp" component={Home} exact />
                <Route path="/webapp/favorites" component={FavoriteLinks} />
                <Route path="/webapp/order_complete" component={OrderComplete} />
                <Route path="/webapp/cart" component={DesktopCart} />
                <Route path="/webapp/desktop_order_complete" component={DesktopOrderComplete} />
                {/* <Route path="/webapp/plan" render={(props) => { return <PlanPage {...props} /> }} />  */}
                {/* <Route path="/image_gallery" component={PlanImageGallery} exact /> */}

            </BrowserRouter>
        );
    }

    componentDidMount(){
        
    }
}

export default App;
